import React from 'react';

export const SellerBenefits: React.FC = () => {
  const benefits = [
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'No Repair Costs',
      description: 'Avoid spending tens or hundreds of thousands on repairs, renovations, or deferred maintenance. We buy garden apartments in any condition, saving you significant capital expenditures.',
      savings: 'Save $50,000 - $500,000+ in repair costs'
    },
    {
      icon: 'ri-time-line',
      title: 'Fast Closing Timeline',
      description: 'Close in as little as 30 days or on your preferred timeline. No waiting for buyer financing approvals or lengthy contingency periods that can delay or derail traditional sales.',
      savings: 'Close 60-90 days faster than traditional sales'
    },
    {
      icon: 'ri-user-line',
      title: 'No Agent Commissions',
      description: 'Selling directly to us eliminates broker commissions, typically 3-6% of the sale price. On a $2 million property, that\'s $60,000-$120,000 saved.',
      savings: 'Save 3-6% of sale price in commissions'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Certainty of Closing',
      description: 'We have capital ready and extensive experience closing garden apartment transactions. No financing contingencies or last-minute surprises that can kill deals.',
      savings: 'Eliminate deal failure risk and uncertainty'
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Simplified Process',
      description: 'We handle the complexity of multifamily transactions. Our team manages due diligence, title work, and closing coordination, making the process smooth for sellers.',
      savings: 'Reduce stress and time commitment'
    },
    {
      icon: 'ri-group-2-line',
      title: 'Keep Tenants in Place',
      description: 'No need to vacate units or terminate leases. We purchase occupied properties and handle all tenant relationships after closing, preserving rental income until sale.',
      savings: 'Maintain income stream until closing'
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'Flexible Closing Dates',
      description: 'Need time to relocate or complete a 1031 exchange? We accommodate your timeline and can structure closings to meet your specific needs and tax planning strategies.',
      savings: 'Optimize timing for your situation'
    },
    {
      icon: 'ri-hand-coin-line',
      title: 'Creative Financing Options',
      description: 'Beyond all-cash purchases, we offer seller financing options that can provide tax advantages through installment sales while generating ongoing income.',
      savings: 'Potential tax savings and income stream'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Benefits of Selling Your Garden Apartments to Us
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
            We make selling your garden apartment property simple, fast, and financially advantageous compared to traditional sales methods.
          </p>
        </div>

        <div className="mb-16">
          <div className="relative overflow-hidden rounded-2xl shadow-2xl">
            <img
              src="https://public.readdy.ai/ai/img_res/56f12ee7cc348bc613c3c19b0b372651.jpg"
              alt="Successful Property Sale"
              className="w-full h-[450px] object-cover object-top"
            />
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-white to-orange-50 rounded-xl border border-orange-100 p-8 hover:shadow-lg transition-all duration-300"
            >
              <div className="flex items-start mb-6">
                <div className="w-16 h-16 bg-orange-500 rounded-xl flex items-center justify-center flex-shrink-0 mr-6">
                  <i className={`${benefit.icon} text-3xl text-white`}></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">
                    {benefit.title}
                  </h3>
                </div>
              </div>
              <p className="text-gray-700 leading-relaxed mb-4">
                {benefit.description}
              </p>
              <div className="pt-4 border-t border-orange-200">
                <div className="flex items-center">
                  <i className="ri-check-double-line text-green-600 text-xl mr-2"></i>
                  <span className="text-sm font-semibold text-green-700">
                    {benefit.savings}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl p-10 text-white">
            <h3 className="text-3xl font-bold mb-4">
              Ready to Experience These Benefits?
            </h3>
            <p className="text-xl mb-8 text-gray-300 max-w-2xl mx-auto">
              Get your free, no-obligation cash offer today and discover how easy selling your garden apartment property can be.
            </p>
            <a
              href="#get-offer"
              className="inline-block px-10 py-5 bg-orange-500 text-white font-bold rounded-lg hover:bg-orange-600 transition-all duration-300 shadow-lg hover:shadow-xl text-lg whitespace-nowrap"
            >
              Get Your Cash Offer Now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};